/* istanbul ignore file */
import { gql } from '@moonpig/web-core-graphql'
import { DepartmentsEnum } from '@moonpig/web-core-types-graphql'
import { getDepartmentTitle } from '@moonpig/web-core-utils'
import { GetSearchSuggestionsQuery } from './__generated__/Suggestions'

type GetSearchSuggestions_searchSuggest_suggestions = NonNullable<
  GetSearchSuggestionsQuery['searchSuggest']['suggestions'][0]
>

export const SUGGESTIONS_LIMIT = 30

export type SearchSuggestion = {
  value: string
  department: {
    enum: DepartmentsEnum
    name: string
    title: string
  }
  isMainSuggestion?: boolean
  resultsCount?: number
  score?: number
  searchKey?: string
  path?: string
  weightedCount?: number
}

export const GetSearchSuggestionsGQL = gql`
  query GetSearchSuggestions(
    $searchTerm: String!
    $limit: Int = 5
    $suggesterType: SuggesterType = DYNAMIC
    $loadCounts: Boolean! = true
    $experimentValues: String
  ) {
    searchSuggest(
      searchTerm: $searchTerm
      limit: $limit
      suggesterType: $suggesterType
      experimentValues: $experimentValues
    ) {
      suggestions {
        searchTerm
        score
        departments
        departmentCounts {
          department
          count @include(if: $loadCounts)
        }
        arguments {
          searchTerm
          filters {
            facets {
              name
              value
              facetKey
              label
              groups {
                group
              }
            }
          }
        }
      }
    }
  }
`

const mapSuggestion = (
  suggestion: GetSearchSuggestions_searchSuggest_suggestions,
): SearchSuggestion[] => {
  return suggestion.departments.map(department => {
    return {
      value: suggestion.searchTerm,
      department: {
        enum: department,
        name: department.toLocaleLowerCase(),
        title: getDepartmentTitle(department),
      },
      searchKey: suggestion.arguments.filters?.facets
        ?.map(
          facet =>
            `${facet.groups[0].group.toLowerCase()}:${facet.facetKey}:${
              facet.label
            }`,
        )
        .join('.'),
    }
  })
}

export const mapDepartmentSuggestions = (
  suggestions: GetSearchSuggestions_searchSuggest_suggestions[],
): SearchSuggestion[] => {
  return suggestions.flatMap(s => mapSuggestion(s))
}
